module.exports = __webpack_public_path__ + "static/media/gothic_bold_italic.aec8cef2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothic_bold_italic.woff
// module id = 267
// module chunks = 1